import language from 'json/languages.json';

export const gameDimensions = {
  horizontal: {
    width: 920,
    height: 800,
  },
  vertical: {
    width: 640,
    height: 990,
  },
};

declare const GBCXPromo;

export class Game extends Phaser.Game {
  public config = {
    backgroundColor: '#3e4272',
    skinId: 0,
    gameOver: false,
    bubbleNames: ['blue', 'green', 'pink', 'red', 'turquoise', 'yellow', 'bomb'],
    skipOneLineTextCaching: true,
  };
  public horizontal: boolean;
  public lang: string;
  public incentivised: boolean;
  public signals = {
    onScreenResize: new Phaser.Signal(),
  };
  public arrowPointer: boolean = true;
  gameDifficultyLevel: number;

  constructor(width: number, height: number) {
    super(width, height, Phaser.CANVAS, '', null, true);

    this.lang = GBCXPromo.getLocale();
    this.incentivised = GBCXPromo.ads.areRewardedAdsSupported();
    this.horizontal = this.detectHorizontal();

    this.state.onStateChange.add(() => {
      Object.values(this.signals).forEach((signal) => signal.removeAll());
    });

    GBCXPromo.setPauseHandler( ()=> {
        this.paused = true;
        this.sound.mute = true;
      
    });

    GBCXPromo.setUnpauseHandler(()=> {
      this.paused = false;
      this.sound.mute = GBCXPromo.storage.getStorageValue('mute', false);
      
    });
  }

  public getText(index: number): string {
    try {
      return language[this.lang][index];
    } catch (e) {
      return 'NOT FOUND';
    }
  }

  private detectHorizontal(): boolean {
    const { width, height } = gameDimensions.horizontal;
    return (width / height) <= (window.innerWidth / window.innerHeight);
  }

  public resizeGame(): void {
    const { width, height } = gameDimensions[this.horizontal ? 'horizontal' : 'vertical'];
    const standardRatio = height / width;

    const ratio = window.innerHeight / window.innerWidth;
    if (ratio < standardRatio) {
      this.scale.setGameSize(Math.floor(height / ratio), height);
      this.world.setBounds(Math.floor((this.width - width) * -0.5), 0, this.width, this.height);
    } else {
      const ratioHeight = Math.floor(width * ratio);
      this.scale.setGameSize(width, Math.max(ratioHeight, height));
      this.world.setBounds(0, 0, this.width, this.height);
    }

    this.signals.onScreenResize.dispatch();
  }
}
